import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { BulletinMessagesCategory } from '../types';
import AccordionLevel from './AccordionLevel';
import EntryAccordion, { hasFormErrorInEntry } from './EntryAccordion';
import { useBulletinMessages } from '../../../../context/bulletin-messages';

export function hasFormErrorInCategory(
  category: BulletinMessagesCategory,
  hasErrors?: Record<string, boolean>,
) {
  if (!hasErrors) {
    return false;
  }
  return Object.keys(hasErrors).some(
    k =>
      (k === category.category && hasErrors[k]) ||
      category.entries.some(e => hasFormErrorInEntry(e, hasErrors)),
  );
}

function CategoryAccordion({
  category,
  index,
}: {
  category: BulletinMessagesCategory;
  index: number;
}) {
  const { hasErrors } = useBulletinMessages();
  const error = hasFormErrorInCategory(category, hasErrors);
  return (
    <AccordionLevel
      title={category.name}
      // @ts-expect-error Will use CategoryFrequency component once backend returns the right data
      subtitle={category.frequency}
      flagLabel="Message on category"
      defaultValue={category.content}
      index={index}
      type="category"
      id={category.path}
      error={error}
    >
      <Accordion defaultActiveKey="0">
        {category.entries.map((entry, entryIndex) => (
          <EntryAccordion
            key={entry.tree_key}
            entry={entry}
            index={entryIndex}
          />
        ))}
      </Accordion>
    </AccordionLevel>
  );
}

export default CategoryAccordion;
